import { Asterisk } from "lucide-react";

const ITEMS = [
  "Creatività applicata",
  "Comunicazione interna",
  "Eventi aziendali",
  "Team building",
  "Video & AI",
  "Soluzioni ad hoc",
];

function Track({ hidden }) {
  return (
    <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display font-semibold uppercase tracking-wide text-2xl sm:text-3xl text-zinc-500 px-6 whitespace-nowrap">
            {item}
          </span>
          <Asterisk className="h-6 w-6 text-ember shrink-0" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div className="marquee-wrap relative border-y border-white/10 bg-surface/60 py-6 overflow-hidden">
      <div className="flex w-max animate-marquee">
        <Track />
        <Track hidden />
      </div>
    </div>
  );
}
